// @flow
import {connect} from "react-redux"
import React, {Component} from "react"
import {injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {Banner} from "@irati/ui/src/Layout"
import domain from "@irati/utils/env/domain"
import DefaultLogin from "./DefaultLogin"
import GlobalLogin from "./GlobalLogin"

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentView: "default"
    }

    if (domain.isGlobal()) {
      this.state.currentView = "global"
    }
  }

  render() {
    /**  containers should force to init the idNamespace */
    const idNamespace = id("login", this.props, {force: true})
    return (
      <div id={id("container", idNamespace)}>
        <Banner id={id("banner", idNamespace)} />
        {this.state.currentView === "global" && <GlobalLogin id={idNamespace} {...this.props} />}
        {this.state.currentView === "default" && <DefaultLogin id={idNamespace} {...this.props} />}
      </div>
    )
  }
}

export const LoginUnconnected = Login

const mapStateToProps = (state) => {
  return {
    userTenant: state.auth.userTenant
  }
}

export default injectIntl(connect(mapStateToProps)(Login))
